import { BaseTranslation } from 'src/i18n/i18n-types';
import { BrandSortOption } from 'src/pages/LibraryV2/routes/Brands/Brands';

const brandSortOptions: Record<BrandSortOption, string> = {
  alphanumeric: 'A-Z',
};

export const brands: BaseTranslation = {
  list: {
    name: {
      header: 'Name',
    },
    category: {
      header: 'Industry',
    },
    liveAdCount: {
      // header: 'Active Ads',
      header: 'Ad Count',
    },
    videos: {
      header: 'Videos',
    },
    images: {
      header: 'Images',
    },
    carousels: {
      header: 'Carousels',
    },
    status: {
      header: 'Last Updated At',
    },
    removeBrand: 'Remove Brand',
  },
  sortBy: 'Sort By',
  brandSortOptions,
  addABrand: 'Add a brand',
  addBrand: 'Add brand',
  inspiration: 'Inspiration',
  addBrandSubheading:
    'Want us to track a brand for you? Just add their page URL below.',
  follow: 'Follow',
  following: 'Following',
  followBrands: 'Follow Brands',
  followBrandsSubheading:
    'Search and follow your favourite brands to see their latest ads appear here.',
  followAndCheck: 'Follow brand and check back later for ads',
  unfollow: 'Unfollow',
  pageURL: 'Page URL',
  addBrandStepsHeading: 'How to get the brand URL?',
  addBrandStepsOne: 'Find their Facebook Page on <>Facebook<>',
  addBrandStepsTwo:
    'Copy the URL of their facebook page, it should look something like <>facebook.com/brandname<>',
  viewBrands: 'View Brands',
  submitBrand: 'Submit Brand',
  invalidUrl:
    'URL must be in the format "facebook.com/brandname" or "https://www.facebook.com/brandname"',
  urlPlaceholder: 'https://www.facebook.com/brandname',
  status: 'Status',
  lastChecked: 'Last checked',
  loadingBrandsEmptyState:
    "We're loading this brand's ads, check back a bit later.",
  indicator: {
    brandsFollowed: 'Brands Followed',
  },
  addBrands: {
    cta: 'Add Brand',
    modal: {
      title: 'Add Brand',
      subtitle:
        'Want us to track a brand for you? Search our brands list or add manually.',
      tab1: {
        title: 'Search',
        inputLabel: 'Brand Name',
        inputPlaceholder: 'MagicBrief',
        searchResultsNone:
          'No results! Try updating your search or adding manually',
      },
      tab2: {
        title: 'Add Manually',
        inputLabel: 'Facebook Library URL',
        inputPlaceholder:
          'https://www.facebook.com/ads/library/?view_all_page_id=111783884885983',
        guide: {
          title: 'How to get the brand library URL:',
          text1: 'Search for the brand in',
          text1LinkText: 'Facebook Ads Library',
          text2: 'Wait for brand results to appear in the autocomplete popup',
          text3: 'When results appear, select the matching brand',
          text4: 'After the brand library page loads, copy the URL',
          text5: 'Paste the link above',
        },
      },
    },
  },
  sections: {
    overview: 'Overview',
    hooks: 'Hooks',
    themes: 'Themes',
    adCopy: 'Ad Copy',
    headlines: 'Headlines',
    landingPages: 'Landing Pages',
    mediaMix: 'Media Mix',
    competitors: 'Competitors',
  },
  overview: {
    activeAds: '{count} Active Ads',
    updatedAgo: 'Updated {time} ago',
    summary: '14 Day Summary',
    metrics: 'Metrics',
    newAds: '<>{count} new ads<> in last {timePeriod}',
    leadTo: 'Lead to <>{count} landing pages<>',
    avgVideoLength: 'Average video length is <>{seconds} seconds<>',
    creativeOutputPositive:
      'Creative <>output is up {amount}<> over last {timePeriod}',
    creativeOutputNegative:
      'Creative <>output is down {amount}<> over last {timePeriod}',
    creativeOutputUnchanged:
      'Creative <>output is unchanged<> over last {timePeriod}',
    creativeVariants: 'Creative <>variants make up {amount}<> of active ads',
  },
  mediaMix: {
    mediaType: 'Media Type',
    count: 'Count',
    percentage: 'Percentage',
  },
  mediaType: {
    video: 'Video',
    image: 'Image',
    carousel: 'Carousel',
    mixed: 'Mixed',
  },
  packs: {
    addPack: 'Add Brand Pack',
    brandPacks: 'Brand Packs',
    searchBrandToAdd: 'Search brand to add',
    enterBrandPackName: 'Enter brand pack name',
    addBrandSubheading: 'Add brands to your pack from the list below',
    emptySearchResults: 'No brands found',
    added: 'Brand pack added',
    updated: 'Brand pack updated',
    deleted: 'Brand pack deleted',
    failedToAdd: 'Failed to add brand pack',
    failedToUpdate: 'Failed to update brand pack',
    failedToDelete: 'Failed to delete brand pack',
    noBrandsAdded: 'You must add at least one brand to the pack',
  },
  followBrand: {
    success: 'Follow successful',
    error: 'Error following brand, please try again: {error}',
  },
  unfollowBrand: {
    success: 'Unfollow successful',
    error: 'Error unfollowing brand, please try again: {error}',
  },
  manualAdd: {
    success: 'Follow successful',
    error: 'Error following brand, please try again: {error}',
  },
  upgrade: {
    badge: 'Pro Feature',
    title: 'The future of creative analytics',
    description:
      'Use powerful creative analytics to guide your iterations and work out what you need to make next.',
    cta: 'Upgrade Plan',
  },
  pending: {
    title: 'Processing Your Requested Brands',
    inProgress: '{count} in progress',
    description:
      'Data collection in progress for your selected brands. You’ll be notified when ready.',
    waitingForData: 'Waiting for data...',
  },
};
